<template>
  <div>
    <p>You do not have access to this resource.</p>
  </div>
</template>

<script>
  export default {
    name: 'Forbidden',
  }
</script>
